import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { AnyAction } from "redux";
import { Link } from "react-router-dom";
import Table from "../../../../core/common/dataTable";
import { all_routes } from "../../../router/all_routes";
import { getAllNocTravel, INocTravel } from "../../../../core/data/redux/nocTravelSlice";

type AppDispatch = ThunkDispatch<any, any, AnyAction>;

interface Pagination {
    current: number;
    pageSize: number;
    total: number;
}

interface SearchParams {
    query: string;
}

const NocTravelMaster = () => {
    const dispatch = useDispatch<AppDispatch>();
    const nocTravelState = useSelector((state: any) => state.nocTravelState);
    const routes = all_routes;

    const [dataList, setDataList] = useState<INocTravel[]>([]);
    const [searchParams, setSearchParams] = useState<SearchParams>({ query: "" });
    const [pagination, setPagination] = useState<Pagination>({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const fetchRecords = useCallback(
        (searchParams: SearchParams, page: number, pageSize: number) => {
            dispatch(getAllNocTravel({ query: searchParams.query, page, limit: pageSize }));
        },
        [dispatch]
    );

    useEffect(() => {
        const delay = setTimeout(() => {
            setPagination((prev) => ({ ...prev, current: 1 }));
        }, 500);
        return () => clearTimeout(delay);
    }, [searchParams]);

    useEffect(() => {
        fetchRecords(searchParams, pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize, searchParams, fetchRecords]);

    useEffect(() => {
        if (Array.isArray(nocTravelState.data)) {
            setDataList(nocTravelState.data);
            setPagination((prev) => ({
                ...prev,
                total: nocTravelState.total || 0,
            }));
        }
    }, [nocTravelState.data, nocTravelState.total]);

    const handlePagination = (newPagination: Pagination) => {
        setPagination(newPagination);
    };

    const handleSearch = (value: string) => {
        setSearchParams({ query: value });
    };

    const getSerialNumber = (index: number) =>
        (pagination.current - 1) * pagination.pageSize + index + 1;

    const formatDate = (dateString?: string) => {
        if (!dateString) return "-";
        return new Date(dateString).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const columns = [
        {
            title: "Sr. No.",
            dataIndex: "id",
            width: 90,
            render: (_: any, __: INocTravel, index: number) => <div>{getSerialNumber(index)}</div>,
        },
        {
            title: "Travel ID",
            dataIndex: "travel_id",
            width: 150,
        },
        {
            title: "Travel Title",
            dataIndex: "travel_title",
            width: 200,
        },
        {
            title: "Created At",
            dataIndex: "sapCreatedAt",
            width: 180,
            render: (date: string) => <div>{formatDate(date)}</div>,
        },
        {
            title: "Modified At",
            dataIndex: "sapModifiedAt",
            width: 180,
            render: (date: string) => <div>{formatDate(date)}</div>,
        },
    ];

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                    <div className="my-auto mb-2">
                        <h3 className="page-title mb-1">NOC Travel Master</h3>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to={routes.adminDashboard}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="#">Masters</Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    NOC Travel Master
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                        <h4 className="mb-4 mt-3">NOC Travel List</h4>
                    </div>

                    <div className="card-body p-0 py-3">
                        <Table
                            columns={columns}
                            dataSource={dataList}
                            Selection={false}
                            paginationConfig={pagination}
                            handlePagination={handlePagination}
                            loading={nocTravelState.loading}
                            handleSearch={handleSearch}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NocTravelMaster;
